import * as React from 'react';
import { pathOr } from 'ramda';
import { useSelector } from 'react-redux';

import { BuilderHousesLink } from './BuilderHousesLink';
import { trackTransferToDeveloperCard } from './tracking';
import { Builder } from '../../components/Builder';
import { getDisplayDescription } from '../../components/Builder/component/utils/getDisplayDescription';
import { getBuilder } from '../../selectors/newbuilding';

export function BuilderContainer() {
  const { logoUrl, name, description, profileUrl, yearOfFoundation, stats, reviewStats, housesBuiltInTime } =
    useSelector(getBuilder);
  const doneStats = pathOr(null, ['done'], stats);
  const inProgressStats = pathOr(null, ['inProgress'], stats);

  return (
    <Builder
      logoUrl={logoUrl}
      name={name}
      yearOfFoundation={yearOfFoundation}
      done={<BuilderHousesLink stats={doneStats} />}
      inProgress={<BuilderHousesLink stats={inProgressStats} />}
      description={getDisplayDescription(description)}
      url={profileUrl}
      onBuilderLinkClick={trackTransferToDeveloperCard}
      reviewStats={reviewStats}
      housesBuiltInTime={housesBuiltInTime}
    />
  );
}
